import { List, Stack, Typography } from '@mui/material';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { SpatialEntity } from '@ekkogmbh/apisdk';
import { DragIndicator } from '@mui/icons-material';

export const SortableItem = SortableElement(
  ({ value, fieldKey, sortIndex }: { value: SpatialEntity; sortIndex: number; fieldKey: string }) => (
    <Stack direction={'row'} justifyContent={'space-between'} sx={{ userSelect: 'none', p: 1 }}>
      <Stack direction={'row'} spacing={1}>
        <DragIndicator color={'secondary'} />
        <Typography color={'secondary'}>{sortIndex + 1}.</Typography>
        <Stack direction={'row'} spacing={1}>
          <Typography fontWeight={700}>{fieldKey}:</Typography>
          <Typography>{value.fields[fieldKey] ?? ''}</Typography>
        </Stack>
      </Stack>

      <Typography color={'secondary'}>
        {/* working around broken or outdated types: */}
        {(value as { baseNode?: { materializedPath?: string } })?.baseNode?.materializedPath ?? ''}
      </Typography>
    </Stack>
  ),
);

export const SortableList = SortableContainer(({ items, fieldKey }: { items: SpatialEntity[]; fieldKey: string }) => (
  <List
    style={{
      padding: 4,
      width: '100%',
    }}
  >
    {items.map((value: SpatialEntity, index: number) => (
      <SortableItem key={`item-${index}`} index={index} sortIndex={index} value={value} fieldKey={fieldKey} />
    ))}
  </List>
));
